import { Component, OnInit } from '@angular/core';

import { ReadinessGap, ReadinessRow } from '../../../../services/suburb-readiness.service';
import { SuburbCatalogueService } from '../workspace/catalogue.service';
import { PageEditorService } from '../workspace/page-editor.service';
import { ReadinessFilters, ReadinessViewService } from '../workspace/readiness-view.service';
import { TEMPLATE_KEYS, TemplateKey } from '../template/suburb-template';
import {
  cellOf,
  GAP_COLUMNS,
  GAP_LABELS,
  gapTarget,
  ReadinessCell,
  STATUS_OPTIONS,
} from './readiness-rules';

/**
 * The Suburbs workspace's Readiness view (#262), beside Map and List: one row per suburb, place and sub-region page
 * with what it has and what's missing, each gap opening the tab that fixes it, an owner and a status per page so the
 * work can be handed out, the filters, the CSV, and the way into the page templates. The state is
 * ReadinessViewService; the rules readiness-rules.ts.
 */
@Component({
  selector: 'app-suburb-readiness',
  templateUrl: './suburb-readiness.component.html',
  styleUrls: ['./suburb-readiness.component.scss'],
})
export class SuburbReadinessComponent implements OnInit {
  readonly columns = GAP_COLUMNS.map((gap) => ({ gap, label: GAP_LABELS[gap] }));
  readonly statusOptions = STATUS_OPTIONS;
  readonly templateKeys = TEMPLATE_KEYS;

  constructor(
    public view: ReadinessViewService,
    public catalogue: SuburbCatalogueService,
    private pageEditor: PageEditorService
  ) {}

  ngOnInit(): void {
    this.view.start();
  }

  filtersChanged(f: ReadinessFilters): void {
    this.view.filters = f;
    this.view.reload();
  }

  onLazyLoad(e: { first?: number; sortField?: string; sortOrder?: number }): void {
    this.view.page(e.first ?? 0, e.sortField, e.sortOrder);
  }

  cell(row: ReadinessRow, gap: ReadinessGap): ReadinessCell {
    return cellOf(row, gap);
  }

  fixable(row: ReadinessRow, gap: ReadinessGap): boolean {
    return gapTarget(row, gap) !== null;
  }

  editTemplate(key: TemplateKey): void {
    this.pageEditor.editTemplate(key);
  }

  kindLabel(row: ReadinessRow): string {
    return row.template === 'subregion'
      ? 'sub-region'
      : row.kind === 'place'
        ? 'place'
        : row.kind
          ? ''
          : 'no kind';
  }

  trackRow(_: number, row: ReadinessRow): string {
    return row.recordId;
  }
}
